var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37,18h-3v-6c0-5.5141602-4.4863281-10-10-10S14,6.4858398,14,12v6h-3c-2.7568359,0-5,2.2431641-5,5v18 c0,2.7568359,2.2431641,5,5,5h26c2.7568359,0,5-2.2431641,5-5V23C42,20.2431641,39.7568359,18,37,18z M16,12 c0-4.4111328,3.5888672-8,8-8s8,3.5888672,8,8v6H16V12z M40,41c0,1.6542969-1.3457031,3-3,3H11c-1.6542969,0-3-1.3457031-3-3V23 c0-1.6542969,1.3457031-3,3-3h26c1.6542969,0,3,1.3457031,3,3V41z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 26,
    width: 2,
    height: 12
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockMedium);
export default __webpack_public_path__ + "static/media/lock--medium.065a7095b87a65068964852386174eff.svg";
export { ForwardRef as ReactComponent };